import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import React from 'react'
import { FormContainer, FormField } from '../forms'
import MaterialSelect from '../selection/MaterialSelect'
import { FieldError } from '../util/errutil'

export interface Value {
  name: string
  owners: string[]
}

interface ServiceSlackListFormProps {
  value: Value
  users: { id: string; name: string; email: string }[]
  errors: FieldError[]
  onChange: (val: Value) => void
  disabled: boolean
}

export default function ServiceSlackListForm(
  props: ServiceSlackListFormProps,
): JSX.Element {
  const { users, ...formProps } = props

  return (
    <FormContainer {...formProps} optionalLabels>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormField
            fullWidth
            component={TextField}
            label='Name'
            name='name'
            required
          />
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {(props.value.owners || []).map((email) => {
              const u = users.find((u) => u.email === email)
              return (
                <Chip
                  key={email}
                  label={u ? u.name : email}
                  onDelete={() => {
                    props.onChange({
                      ...props.value,
                      owners: props.value.owners.filter((o) => o !== email),
                    })
                  }}
                />
              )
            })}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <MaterialSelect
            fullWidth
            label='Add Owner'
            multiple={false}
            clientSideFilter
            value={null}
            options={users
              .filter((u) => !(props.value.owners || []).includes(u.email))
              .map((u) => ({
                label: u.name,
                value: u.email,
                subText: u.email,
              }))}
            onChange={(selected: any) => {
              if (!selected) return
              props.onChange({
                ...props.value,
                owners: [...(props.value.owners || []), selected.value],
              })
            }}
          />
        </Grid>
      </Grid>
    </FormContainer>
  )
}
